import styled from 'styled-components';

export const ErrorMessage = styled.div`
    color: firebrick;
    font-family: "GothamLight";
`;


// WEBPACK FOOTER //
// ./src/common/components/ErrorMessage.js